"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = App;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var get_firebase_user_profile_1 = require("./api/calls/user/get_firebase_user_profile");
var auth_1 = require("./features/slices/auth");
var user_profile_1 = require("./features/slices/user-profile");
var main_1 = require("./screens/main");
var hooks_1 = require("./store/hooks");
var auth_persistence_1 = require("./utils/auth-persistence");
var firebase_1 = require("./utils/firebase");
function App() {
    var dispatch = (0, hooks_1.useAppDispatch)();
    var auth = (0, hooks_1.useAppSelector)(function (s) { return s.auth; });
    (0, react_2.useEffect)(function () {
        // Initialize auth state from persisted storage on app start
        var initializeAuth = function () {
            // First try to load from our auth persistence utility (handles Sky Lifestyle and legacy auth)
            var persistedAuth = (0, auth_persistence_1.loadPersistedAuthState)();
            if (persistedAuth) {
                dispatch((0, auth_1.setCredentials)(persistedAuth));
            }
        };
        initializeAuth();
    }, [dispatch]);
    // After auth is available, fetch Firebase user profile once per session
    (0, react_2.useEffect)(function () {
        var _a;
        // firebaseAuth.currentUser may be null before auth state resolves on
        // first load — the fallback chain covers that window until onAuthStateChanged fires.
        var currentUserUid = (_a = firebase_1.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid;
        var firebaseUid = currentUserUid ||
            (auth === null || auth === void 0 ? void 0 : auth.firebase_user_id) ||
            localStorage.getItem("firebase_user_id");
        if ((auth === null || auth === void 0 ? void 0 : auth.access_token) && firebaseUid) {
            // Only sync localStorage when UID came from an authoritative source
            if (currentUserUid) {
                localStorage.setItem("firebase_user_id", currentUserUid);
            }
            (0, get_firebase_user_profile_1.get_firebase_user_profile)(firebaseUid)
                .then(function (res) {
                var _a;
                if (res.success && ((_a = res.content) === null || _a === void 0 ? void 0 : _a.sanitized)) {
                    var sanitizedProfile = res.content.sanitized;
                    dispatch((0, user_profile_1.setFirebaseUserProfile)(sanitizedProfile));
                    var facetecDBRef = sanitizedProfile === null || sanitizedProfile === void 0 ? void 0 : sanitizedProfile.facetecDBRef;
                    if (facetecDBRef) {
                        dispatch((0, auth_1.setFacetecDBRef)(facetecDBRef));
                    }
                }
            })
                .catch(function (err) {
                console.error("Error fetching Firebase user profile:", err);
            });
        }
    }, [auth === null || auth === void 0 ? void 0 : auth.access_token, auth === null || auth === void 0 ? void 0 : auth.firebase_user_id, dispatch]);
    return ((0, jsx_runtime_1.jsx)(react_1.HeroUIProvider, { children: (0, jsx_runtime_1.jsx)(main_1.MainScreen, {}) }));
}
